/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_No_EventsInputs */

const en_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events found to preview`)
};

const fr_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement a previsualiser`)
};

const de_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ereignisse zur Vorschau gefunden.`)
};

const it_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento trovato da visualizzare in anteprima`)
};

const ru_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События для предварительного просмотра не найдены.`)
};

const es_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron eventos para previsualizar`)
};

const zh_cn2_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到可预览的活动`)
};

const ja_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューするイベントが見つかりません`)
};

const hi_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन के लिए कोई इवेंट नहीं मिले`)
};

const pt_pt2_video_export_preview_no_events = /** @type {(inputs: Video_Export_Preview_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento encontrado para pré-visualização.`)
};

/**
* | output |
* | --- |
* | "No events found to preview" |
*
* @param {Video_Export_Preview_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_no_events = /** @type {((inputs?: Video_Export_Preview_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_no_events(inputs)
	if (locale === "de") return de_video_export_preview_no_events(inputs)
	if (locale === "it") return it_video_export_preview_no_events(inputs)
	if (locale === "ru") return ru_video_export_preview_no_events(inputs)
	if (locale === "es") return es_video_export_preview_no_events(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_no_events(inputs)
	if (locale === "ja") return ja_video_export_preview_no_events(inputs)
	if (locale === "hi") return hi_video_export_preview_no_events(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_no_events(inputs)
	return en_video_export_preview_no_events(inputs)
});